// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { _ } from "~/i18n";

/**
 * @private
 */
 export default class ManageMyCompany extends Content {
	_build() {
		this._dom.container.classList.add("content-managemycompany");

		let link = Mapy.Util.node("a", { href: this._data, target: "_blank", textContent: _("detail.content.review2.manageOwnCompany") });
		this._dom.container.appendChild(link);
	}
}
